/**
 * Avora — Shopify theme checkout redirect (REVO-style ?cartid=)
 *
 * Install:
 * 1. Online Store → Themes → Edit code
 * 2. Assets → Add a new asset: avora-checkout-redirect.js (paste this file)
 * 3. In layout/theme.liquid before </body>, add:
 *      <script src="{{ 'avora-checkout-redirect.js' | asset_url }}" defer></script>
 *
 * Or paste into a Custom Liquid section / theme JS file.
 *
 * Flow: intercept Checkout → GET /cart.js → POST snapshot API → redirect
 *   https://secure.avora-france.com/?cartid=<uuid>
 */
(function () {
  'use strict';

  var CHECKOUT_BASE = 'https://secure.avora-france.com';
  var SNAPSHOT_URL = CHECKOUT_BASE + '/api/cart-snapshot.php';

  /** Dawn / common theme checkout controls — extend if your theme differs. */
  var CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'form[action="/cart"] button[type="submit"][name="checkout"]',
    'form[action="/cart"] input[type="submit"][name="checkout"]',
    '#checkout',
    '.cart__checkout',
    '.cart__checkout-button',
    '[name="checkout"]',
    'a[href="/checkout"]',
    'a[href$="/checkout"]',
    '#CartDrawer-Checkout',
    '.cart-drawer__checkout',
  ].join(',');

  var redirecting = false;

  function goBareCheckout() {
    window.location.href = CHECKOUT_BASE + '/';
  }

  function goWithCartId(cartid) {
    window.location.href =
      CHECKOUT_BASE + '/?cartid=' + encodeURIComponent(cartid);
  }

  function isCheckoutControl(el) {
    if (!el || el.nodeType !== 1) {
      return false;
    }

    if (el.matches && el.matches(CHECKOUT_SELECTOR)) {
      return true;
    }

    var name = (el.getAttribute && el.getAttribute('name')) || '';
    if (name === 'checkout') {
      return true;
    }

    var href = (el.getAttribute && el.getAttribute('href')) || '';
    if (href === '/checkout' || /\/checkout\/?(\?|$)/.test(href)) {
      return true;
    }

    return false;
  }

  function findCheckoutControl(target) {
    var node = target;
    while (node && node !== document) {
      if (isCheckoutControl(node)) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  function postSnapshot(cart) {
    return fetch(SNAPSHOT_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cart),
      mode: 'cors',
      credentials: 'omit',
    }).then(function (res) {
      return res.json().then(function (data) {
        return { res: res, data: data };
      });
    });
  }

  function startCheckoutRedirect(event) {
    if (redirecting) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    redirecting = true;

    fetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('cart.js HTTP ' + res.status);
        }
        return res.json();
      })
      .then(function (cart) {
        if (
          !cart ||
          !Array.isArray(cart.items) ||
          !cart.item_count ||
          cart.item_count < 1
        ) {
          window.location.href = '/cart';
          return null;
        }

        return postSnapshot(cart);
      })
      .then(function (result) {
        if (!result) {
          return;
        }

        var data = result.data || {};
        if (data.ok && data.cartid) {
          goWithCartId(data.cartid);
          return;
        }

        console.warn('Avora cart snapshot failed; bare checkout redirect', data);
        goBareCheckout();
      })
      .catch(function (err) {
        console.error('Avora checkout redirect error', err);
        goBareCheckout();
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var control = findCheckoutControl(event.target);
      if (!control) {
        return;
      }
      startCheckoutRedirect(event);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') {
        return;
      }

      var action = (form.getAttribute('action') || '').toLowerCase();
      var hasCheckout =
        form.querySelector('[name="checkout"]') ||
        action.indexOf('/cart') !== -1;

      // Only intercept cart forms that would hit Shopify checkout.
      if (!hasCheckout) {
        return;
      }

      // If submitter is checkout (or form is cart checkout), redirect.
      var submitter = event.submitter || null;
      if (submitter && isCheckoutControl(submitter)) {
        startCheckoutRedirect(event);
        return;
      }

      if (
        action === '/cart' ||
        action.indexOf('/cart') === 0 ||
        form.querySelector('button[name="checkout"], input[name="checkout"]')
      ) {
        // Dynamic checkout / additional buttons may still post to cart;
        // only redirect when a checkout-named control is present and clicked.
        if (submitter && (submitter.name === 'checkout' || isCheckoutControl(submitter))) {
          startCheckoutRedirect(event);
        }
      }
    },
    true
  );
})();
